import { getGtmData } from '..';

const kyc = () => ({
  kycPageLoad: () => {
    ({
      event: 'event',
      page: 'page',
      title: 'title',
      cd2: getGtmData('cd2'),
    });
  },
});

export default kyc;
